import { useLocation, useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getProjectFromId } from '../projects-reducer';
import { getSupportLink } from '../project-model';
import { useUser } from '../../user/useUser';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import { useState } from 'react';

export const useMemoryBookAction = (pageViewEvent) => {
    const { projectId } = useParams();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const project = useSelector((state) => getProjectFromId(state, projectId));
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const user = useUser();

    useEffect(() => {
        if (!project?.id) {
            return null;
        }
        trackPageView({
            urlAsEvent: pageViewEvent,
            properties: {
                'project-id': project.id,
            },
        });
    }, [pageViewEvent, project?.id]);

    const defaultValues = {
        name: [user.first, user.last].filter(Boolean).join(' '),
        email: user.email ?? '',
    };

    const dismissSupport = () => {
        navigate(`/project/${projectId}/history`);
    };

    const navigateToPayment = ({ memorialCommentId, authorName } = {}) => {
        const supportLink = getSupportLink({ projectId: project.id, currentPathname: location?.pathname });
        navigate(supportLink, {
            ...(memorialCommentId ? { state: { memorialCommentId, authorName } } : {}),
        });
    };

    return {
        project,
        dispatch,
        isSubmitted,
        setIsSubmitted,
        isLoading,
        setIsLoading,
        error,
        setError,
        dismissSupport,
        navigateToPayment,
        defaultValues,
    };
};
